export default __webpack_public_path__ + "static/media/twiter-share.d0e38067.svg";